/* The House of Cobalt, cart page JS.
 *
 * Handles: per-line quantity +/- buttons, quantity input updates, remove,
 * live subtotal refresh via /cart/change.js, and the shipping-meter fill.
 */
(function () {
  var form = document.getElementById('CartForm');
  if (!form) return;

  var THRESHOLD = 10000; // $100 in cents, free shipping threshold

  function money(cents) {
    var n = cents / 100;
    return '$' + (Math.round(n * 100) / 100).toString().replace(/\.00$/, '');
  }

  function updateMeter(total) {
    var meter = document.querySelector('.cart-ship-meter');
    if (!meter) return;
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    var fill = meter.querySelector('.meter-fill');
    if (fill) fill.style.width = pct + '%';
    var text = meter.querySelector('.meter-text');
    if (text) {
      if (total >= THRESHOLD) {
        text.classList.add('meter-done');
        text.textContent = 'Complimentary standard shipping unlocked.';
      } else {
        text.classList.remove('meter-done');
        text.innerHTML = 'Add <strong>' + money(THRESHOLD - total) + '</strong> more for complimentary standard shipping.';
      }
    }
  }

  function updateSubtotalEl(cents) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = money(cents);
    });
  }

  function refreshFromCart(cart) {
    updateSubtotalEl(cart.total_price);
    updateMeter(cart.total_price);
    // Update bag badge in header if present
    document.querySelectorAll('.bag-badge').forEach(function (b) {
      b.textContent = cart.item_count;
    });
  }

  function changeQuantity(lineIdx, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIdx + 1, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (cart) {
        refreshFromCart(cart);
        // If a line was removed (quantity 0), reload to re-render the list.
        // Otherwise update just the line price by reloading the line node.
        if (quantity === 0) {
          window.location.reload();
        } else {
          // Update line price by fetching cart.js again with line.html, simpler is just to reload the line price text.
          // We update by re-fetching cart and matching index.
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (full) {
            var item = full.items[lineIdx];
            if (!item) return;
            var line = document.querySelector('.cart-line[data-line="' + (lineIdx + 1) + '"]');
            if (!line) return;
            var priceEl = line.querySelector('.line-price .now');
            if (priceEl) priceEl.textContent = money(item.final_line_price);
            var input = line.querySelector('[data-cart-qty]');
            if (input) input.value = item.quantity;
          });
        }
      })
      .catch(function () {
        alert('Could not update cart. Please refresh and try again.');
      });
  }

  // Quantity buttons
  form.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn) {
      var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
      var line = stepBtn.closest('.cart-line');
      var input = line.querySelector('[data-cart-qty]');
      var idx = parseInt(input.getAttribute('data-cart-qty'), 10);
      var newQty = Math.max(0, parseInt(input.value, 10) + step);
      input.value = newQty;
      changeQuantity(idx, newQty);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var idx2 = parseInt(rm.getAttribute('data-cart-remove'), 10);
      changeQuantity(idx2, 0);
    }
  });

  // Direct quantity input
  form.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var idx = parseInt(input.getAttribute('data-cart-qty'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeQuantity(idx, qty);
  });

  // Intercept form submit so /checkout posts cleanly
  form.addEventListener('submit', function (e) {
    // Let Shopify handle the standard form post; nothing custom needed unless we
    // wanted to fire analytics.
  });
})();
